import React from 'react';

export const ChartImg = () => {
  return (
    <svg
      width="100%"
      height={156}
      viewBox="0 0 296 156"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
    >
      <path
        d="M222.706 99.111c-6.762-5.926-2.818-11.028 0-12.839-57.756-2.469-170.837-5.926-161.117 0 9.719 5.926 4.049 12.345 0 14.814 56.523 1.811 167.878 3.951 161.117-1.975zM238.5 67.313c-6.4-6-2.667-11.167 0-13-54.667-2.5-161.7-6-152.5 0 9.2 6 3.833 12.5 0 15 53.5 1.833 158.9 4 152.5-2z"
        fill="#f4f5f7"
        fillRule="nonzero"
      />
      <path
        d="M260 45c0-6.623-5.377-12-12-12H12C5.377 33 0 38.377 0 45s5.377 12 12 12h236c6.623 0 12-5.377 12-12zM296 77c0-6.623-5.377-12-12-12H48c-6.623 0-12 5.377-12 12s5.377 12 12 12h236c6.623 0 12-5.377 12-12zM245 107c0-5.519-4.481-10-10-10H27c-5.519 0-10 4.481-10 10s4.481 10 10 10h208c5.519 0 10-4.481 10-10z"
        fill="#f4f5f7"
      />
      <path
        d="M193.66 12.312c-.648-2.11-2.887-3.299-4.998-2.651L79.672 43.085c-2.11.647-3.298 2.887-2.651 4.997l29.32 95.605c.647 2.111 2.887 3.299 4.997 2.652l108.99-33.425c2.11-.647 3.298-2.886 2.65-4.997L193.66 12.312z"
        fill="#8f959f"
      />
      <path
        d="M211 28c0-2.208-1.792-4-4-4H93c-2.208 0-4 1.792-4 4v100c0 2.208 1.792 4 4 4h114c2.208 0 4-1.792 4-4V28z"
        fill="#d1d4dc"
      />
      <path fill="#f4f5f7" d="M97 83h30v41H97zM135 68h30v56h-30zM173 39h30v85h-30z" />
      <path d="M100 86l28-34 43 16 26-32" fill="none" stroke="#8f959f" />
      <circle cx="100" cy="86" r="4" fill="#8f959f" />
      <circle cx="128" cy="52" r="4" fill="#8f959f" />
      <circle cx="171" cy="68" r="4" fill="#8f959f" />
      <circle cx="197" cy="36" r="4" fill="#8f959f" />
      <path d="M114 102l27-21 38 10.5L197.5 60" fill="none" stroke="#d1d4dc" />
      <circle cx="114" cy="102" r="4" fill="#d1d4dc" />
      <circle cx="141" cy="81" r="4" fill="#d1d4dc" />
      <circle cx="179" cy="91" r="4" fill="#d1d4dc" />
      <circle cx="197" cy="60" r="4" fill="#d1d4dc" />
    </svg>
  );
};
